import { ActionTypes } from "../type";

const initialState ={
    country:null
}

export const countryReducer = (state=initialState,action)=>{
    switch (action.type){
        case ActionTypes.COUNTRY:
            return {...state,country:action.payload}
        default:
            return state;
    }
}